export function chartOptions({ stacked = true, ticks = true } = {}) {
  return ({
    animation: false,
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        stacked: stacked
      },
      y: {
        stacked: stacked,
        ticks: {
          display: ticks
        }
      }
    },
    plugins: {
      tooltip: {
        enabled: false,
      },
      legend: {
        display: true,
      }
    }
  });
}
